import React from 'react';
import Script from 'react-inline-script';
import AnalyticsProvider from './AnalyticsProvider';
import EmbeddedHead from './EmbeddedHead';

function IframePage({ head, useFullstory, analyticsProvider, children }) {
  return (
    <>
      <EmbeddedHead title={head.title} useFullstory={useFullstory}>
        <Script>
          {`
              window['_fs_is_outer_script'] = true;
           `}
        </Script>
        <base target="_parent" />
      </EmbeddedHead>
      <AnalyticsProvider {...analyticsProvider}>{children}</AnalyticsProvider>
    </>
  );
}

export default IframePage;
